import React from "react";

import dapp from "../Assests/images/banner/dapp/dapp-kit.png"
import dapp1 from "../Assests/images/banner/dapp/1.jpg"
import dapp2 from "../Assests/images/banner/dapp/2.jpg"
import dapp3 from "../Assests/images/banner/dapp/3.jpg"
import DChainStarterKit from "../Assests/D-Chain Starter Kit.rar"



class App extends React.Component {


  render() {
    return (
      <div className="App">



        <section className=" internal-page-padding-top pb-5">
          <div className="container d-chain-pos-banner-section">
            {/* <p className="banner-text-2 text-start">D-CHAIN</p> */}
            <div class="row">
              <div class="col">
                <h1 className="text-center fw-bold mb-5">Privacy Policy</h1>
                <main>
                  <aside class="sidebar-left">
                    <ol className="p-0 m-0 mb-5">
                      <li>
                        <nav id="navbar-example3" class="h-100 flex-column align-items-stretch">
                          <nav class="nav nav-pills flex-column">
                            <a class="nav-link ms-2" href="#item-1-1">Privacy Policy</a>
                            <a class="nav-link ms-2" href="#item-1-2">Information</a>
                            <a class="nav-link ms-2" href="#item-1-3">Cookies</a>
                            <a class="nav-link ms-2" href="#item-1-4">Advertising</a>
                            <a class="nav-link ms-2" href="#item-1-5">Protection</a>
                            <a class="nav-link ms-2" href="#item-1-6">Data Retention</a>

                          </nav>
                        </nav>
                      </li>


                    </ol>
                  </aside>
                  <section className="d-chain-scroll-container">
                    <div data-bs-spy="scroll" data-bs-target="#navbar-example3" data-bs-smooth-scroll="true" class="scrollspy-example-2" tabindex="0">
                      <div id="item-1-1">
                        <p>At d-ecosystem, accessible from <a href="https://d-ecosystem.io/" className="DChainStarterKit">https://d-ecosystem.io/</a>, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that are collected and recorded by d-ecosystem and how we use it.</p>

                        <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us <a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@d-ecosystem.io&amp;su=SUBJECT&amp;body=BODY&amp;" className="DChainStarterKit" target="_blank" rel="noopener noreferrer">info@d-ecosystem.io</a>.</p>

                        <p>This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the information that they shared and/or collect in d-ecosystem. This policy is not applicable to any information collected offline or via channels other than this website.</p>

                        <h3>Consent</h3>
                        <p>By using our website, you hereby consent to our Privacy Policy and agree to its terms.</p>
                      </div>

                      <div id="item-1-2">

                        <h4>Information we collect</h4>
                        <p>The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the point we ask you to provide your personal information.</p>
                        <p>If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of the message and/or attachments you may send us, and any other information you may choose to provide.</p>
                        <p>When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email address, and telephone number.</p>

                        <h3>How we use your information</h3>
                        <p>We use the information we collect in various ways, including:</p>
                        <ul>
                          <li>Provide, operate, and maintain our website</li>
                          <li>Improve, personalize, and expand our website</li>
                          <li>Understand and analyze how you use our website</li>
                          <li>Develop new products, services, features, and functionality</li>
                          <li>Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes</li>
                          <li>Send you emails</li>
                          <li>Find and prevent fraud</li>
                        </ul>


                        <h3>Log Files</h3>
                        <p>D-ecosystem follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this and are a part of hosting services' analytics. The information collected by log files includes internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information.</p>
                      </div>

                      <div id="item-1-3">

                        <h4>Cookies and Web Beacons</h4>
                        <p>
                          Like any other website, d-ecosystem uses "cookies". These cookies are used to store information including visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page content based on visitors' browser type and/or other information.
                        </p>
                        <h3>Choice, Deletion, and Access</h3>
                        <p>If you need to update or delete information about yourself or your interactions with the Services or the Site, please contact us.</p>
                        <p>You may have options regarding the collection and use of information about yourself. You can refuse to provide certain information, but you may be unable to use certain Services or access certain features of the Site as a result.</p>

                        <p><h5>Communications:</h5>Please unsubscribe or change your communication preferences if you do not want to receive promotional messages from us.</p>
                        <p><h5>Browsers and mobile devices:</h5>Most browsers and devices have a help feature that will tell you how to prevent your browser or device from accepting new cookies, as well as how to have the browser notify you when you receive a new cookie.</p>
                      </div>

                      <div id="item-1-4">

                        <h4>Advertising Partners Privacy Policies</h4>
                        <p>You may consult this list to find the Privacy Policy for each of the advertising partners of d-ecosystem.</p>
                        <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that appear on d-ecosystem, which are sent directly to users' browser. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.</p>
                        <p>Note that d-ecosystem has no access to or control over these cookies that are used by third-party advertisers.</p>

                        <h4>Third-Party Privacy Policies</h4>
                        <p>d-ecosystem's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt out of certain options. </p>
                        <p>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found on the browsers' respective websites.</p>
                      </div>


                      <div id="item-1-5">

                        <h4>CCPA Privacy Rights (Do Not Sell My Personal Information)</h4>
                        <p>Under the CCPA, among other rights, consumers have the right to:</p>
                        <ul>
                          <li>Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal data that a business has collected about consumers.</li>
                          <li>Request that a business delete any personal data about the consumer that a business has collected.</li>
                          <li>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</li>
                          <li>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us <a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@d-ecosystem.io&amp;su=SUBJECT&amp;body=BODY&amp;" className="DChainStarterKit" target="_blank" rel="noopener noreferrer">info@d-ecosystem.io</a></li>
                        </ul>

                        <h3>GDPR Data Protection Rights</h3>
                        <p>We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:</p>
                        <ul>
                          <li><span className="fw-bold">The right to access</span> – You have the right to request copies of your personal data. We may charge you a small fee for this service.</li>
                          <li><span className="fw-bold">The right to rectification</span> You have the right to request that we correct any information you believe is inaccurate. You also have the right to request that we complete the information you believe is incomplete.</li>
                          <li><span className="fw-bold">The right to erasure</span> You have the right to request that we erase your personal data, under certain conditions.</li>
                          <li><span className="fw-bold">The right to restrict processing </span> You have the right to request that we restrict the processing of your personal data, under certain conditions.</li>
                          <li><span className="fw-bold">The right to object to processing</span>You have the right to object to our processing of your personal data, under certain conditions.</li>
                          <li><span className="fw-bold">The right to data portability</span>You have the right to request that we transfer the data that we have collected to another organization, or directly to you, under certain conditions.</li>
                        </ul>
                        <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</p>

                        <h3>Children's Information</h3>
                        <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
                        <p>D-ecosystem does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>
                      </div>

                      <div id="item-1-6">

                        <h4>Data Retention</h4>
                        <p>We keep information collected in accordance with this Privacy Policy for as long as is required to fulfill the relevant purposes described in this Privacy Policy, unless a longer retention period is required or permitted by law, such as for tax, accounting, fraud prevention, investigative, and dispute resolution purposes, or to establish or defend a Claim. We may anonymize personal information about you in some cases so that it cannot be used to identify you, in which case we may use such information indefinitely without further notice to you.</p>

                        <h3>Changes to This Privacy Policy</h3>
                        <p>We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p>


                        <h4>Contact Us</h4>
                        <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us <a href="https://mail.google.com/mail/?view=cm&amp;fs=1&amp;to=info@d-ecosystem.io&amp;su=SUBJECT&amp;body=BODY&amp;" className="DChainStarterKit" target="_blank" rel="noopener noreferrer">info@d-ecosystem.io</a></p>
                      </div>




                    </div>


                  </section>

                </main>
              </div>
            </div>
          </div>
        </section>





      </div>
    );
  }
}

export default App;
